import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Building2, Users, Shield } from "lucide-react";

const Index = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-secondary/20 to-accent/10">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              Bienvenue sur votre SaaS
            </h1>
            <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
              Une plateforme moderne pour gérer vos organisations et collaborer avec votre équipe.
            </p>
          </div>

          <Button 
            onClick={() => navigate("/auth")} 
            size="lg"
            className="text-lg px-8 py-6 shadow-[var(--shadow-medium)] transition-[var(--transition-smooth)] hover:scale-105"
          >
            Commencer
          </Button>

          <div className="grid md:grid-cols-3 gap-8 mt-20">
            <div className="p-6 rounded-xl bg-card shadow-[var(--shadow-soft)] transition-[var(--transition-smooth)] hover:shadow-[var(--shadow-medium)]">
              <Building2 className="h-12 w-12 text-primary mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Organisations</h3>
              <p className="text-muted-foreground">
                Rejoignez ou créez des organisations pour structurer votre travail.
              </p>
            </div>

            <div className="p-6 rounded-xl bg-card shadow-[var(--shadow-soft)] transition-[var(--transition-smooth)] hover:shadow-[var(--shadow-medium)]">
              <Users className="h-12 w-12 text-accent mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Collaboration</h3>
              <p className="text-muted-foreground">
                Travaillez en équipe avec les membres de votre organisation.
              </p>
            </div>

            <div className="p-6 rounded-xl bg-card shadow-[var(--shadow-soft)] transition-[var(--transition-smooth)] hover:shadow-[var(--shadow-medium)]">
              <Shield className="h-12 w-12 text-primary mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Sécurité</h3>
              <p className="text-muted-foreground">
                Vos données sont protégées avec un système d'authentification sécurisé.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
